<template>
  <div class="detailed-lesson-plan-report">
    <a-spin :spinning="loading">
      <div class="air__utils__heading">
        <div class="row">
          <div class="col-12">
            <h5 v-if="reportHeader.lesson_plan_name">
              {{ reportHeader.lesson_plan_name }}
            </h5>
            <div class="text-muted" v-if="reportHeader.class_name && reportHeader.subject_name">
              {{ reportHeader.class_name }} / {{ reportHeader.subject_name }}
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-xl-12">

          <div class="row align-items-center mb-4">
            <div class="col-md-3 col-12 mb-2">
              <a-select
                size="large"
                v-model="selectedTerm"
                placeholder="Filter by Academic Term"
                style="width: 100%"
                @change="fetchDetailedReportData"
              >
                <a-select-option :value="undefined">All Academic Terms</a-select-option>
                <a-select-option v-for="term in terms" :key="term.id" :value="term.id">
                  {{ term.name }}
                </a-select-option>
              </a-select>
            </div>

            <div class="col-md-3 col-12 mb-2">
              <a-select
                size="large"
                v-model="selectedSection"
                placeholder="Filter by Section"
                style="width: 100%"
                @change="fetchDetailedReportData"
              >
                <a-select-option :value="undefined">All Sections</a-select-option>
                <a-select-option v-for="section in sections" :key="section.id" :value="section.id">
                  {{ section.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>

          <a-card :bordered="false">
            <a-tabs default-active-key="bySection" @change="handleTabChange">

              <a-tab-pane key="bySection" tab="Progress by Section">
                <ProgressBySectionTable
                  :data="progressBySectionData"
                  :loading="dataLoading"
                  @viewProgress="handleViewSectionProgress"
                />
              </a-tab-pane>

              <a-tab-pane key="byTopic" tab="Progress by Topic">
                <ProgressByTopicTable
                  :data="progressByTopicData"
                  :loading="dataLoading"
                />
              </a-tab-pane>

              <a-tab-pane key="byMatrix" tab="Section Comparison Matrix">
                <ProgressByMatrixTable
                  :matrixData="matrixGridData"
                  :loading="dataLoading"
                />
              </a-tab-pane>

            </a-tabs>
          </a-card>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import ProgressBySectionTable from '@/components/lessonplan/report/detailReport/progressBySection/Table'
import ProgressByTopicTable from '@/components/lessonplan/report/detailReport/progressByTopic/Table'
import ProgressByMatrixTable from '@/components/lessonplan/report/detailReport/progressByMatrix/Table'

export default {
  props: {
    plan_id: [String, Number],
  },
  components: {
    ProgressBySectionTable,
    ProgressByTopicTable,
    ProgressByMatrixTable,
  },
  data() {
    return {
      loading: true,
      dataLoading: true,
      selectedTerm: undefined,
      selectedSection: undefined,
      terms: [],
      sections: [],
      progressBySectionData: [],
      progressByTopicData: [],
      matrixGridData: { sections: [], topics: [] },
      reportHeader: {},
    }
  },
  computed: {
    planId() {
      return this.$route.params.plan_id
    },
  },
  mounted() {
    this.fetchDetailedReportData()
    this.getTerms()
    this.getSection()
  },
  methods: {
    getTerms() {
      this.$http.get('api/lesson-plan/academic-terms').then(({ data }) => {
        this.terms = data.data
      }).catch((error) => {
        console.error('Error fetching academic terms:', error)
      })
    },
    getSection() {
      this.$http.get('/api/section').then(({ data }) => {
        this.sections = data.data
      }).catch((error) => {
        console.error('Error fetching sections:', error)
      })
    },
    fetchDetailedReportData() {
      this.$http.get('/api/lesson-plan/reports/lesson-plan/' + this.planId, {
        params: {
          academic_term_id: this.selectedTerm,
          section_id: this.selectedSection,
        },
      })
        .then(({ data }) => {
          const report = data.data
          this.reportHeader = {
            lesson_plan_name: report.lesson_plan.name || 'N/A',
            class_name: report.lesson_plan.class || 'N/A',
            subject_name: report.lesson_plan.subject || 'N/A',
          }
          this.progressBySectionData = report.progress_by_section || []
          if (report.progress_by_topic && !Array.isArray(report.progress_by_topic)) {
            this.progressByTopicData = Object.values(report.progress_by_topic)
          } else {
            this.progressByTopicData = report.progress_by_topic || []
          }
          this.matrixGridData = report.matrix_grid || { sections: [], topics: [] }
          this.dataLoading = false
          this.loading = false
        })
        .catch(error => {
          console.error('Error fetching detailed lesson plan report:', error)
          this.$neoNotify.error('Failed to load detailed report.')
          this.dataLoading = false
          this.loading = false
        })
    },

    handleTabChange(key) {
      console.log('Tab changed to:', key)
      // If needed, you could re-fetch data here if each tab's data requires a separate, smaller API call
    },

    handleViewSectionProgress(record) {
      this.$router.push({
        name: 'lessonplan-section-progress-report',
        params: {
          plan_id: this.planId,
          section_id: this.sections.find(sec => sec.name === record.section).id || null,
        },
      })
    },
  },
}
</script>

<style scoped>
/* Optional: Add basic styling for header/layout */
.text-muted {
    font-size: 0.9em;
    color: #8c8c8c;
}
</style>
